import React, { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { arrayOf, func, string, object } from "prop-types";

import CurrentLocationButton from "../CurrentLocationButton";
import MapFilterButton from "../MapFilterButton";
import MapFilter from "../MapFilter";
import { desktop } from "../../shared/utils";
import { testDriveType } from "@types";

const MapWrapper = styled.div`
  position: relative;
  width: 100%;

  ${desktop`
    height: 100vh;
    margin-bottom: 0;
  `}
`;

const MapContainer = styled(motion.div)`
  height: 600px;
  width: 100vw;

  ${desktop`
    height: 100vh;
    width: 100%;
  `}
`;

const CurrentLocationButtonWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column-reverse;

  ${desktop`flex-direction: row;`}
`;

const MapMenuWrapper = styled.div`
  position: absolute;
  bottom: 0.5rem;
  right: 0;
`;

const MapSection = ({
  mapContainerRef,
  accentColor,
  handleSetAddress,
  typeFilter,
  setTypeFilter,
  testDriveTypes,
}) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  return (
    <MapWrapper id="sticky-element">
      <MapContainer ref={mapContainerRef} />
      <MapMenuWrapper>
        <CurrentLocationButtonWrapper
          isFilterOpen={isFilterOpen}
          initial={{ y: 0 }}
          animate={{ y: isFilterOpen ? -142 : 0 }}
        >
          <MapFilterButton
            setIsFilterOpen={setIsFilterOpen}
            accentColor={accentColor}
            isFilterOpen={isFilterOpen}
          />
          <CurrentLocationButton
            setAddress={handleSetAddress}
            accentColor={accentColor}
            isFilterOpen={isFilterOpen}
          />
        </CurrentLocationButtonWrapper>
      </MapMenuWrapper>
      <MapFilter
        filter={typeFilter}
        setFilter={setTypeFilter}
        isFilterOpen={isFilterOpen}
        testDriveTypes={testDriveTypes}
      />
    </MapWrapper>
  );
};

MapSection.propTypes = {
  mapContainerRef: object.isRequired,
  accentColor: string.isRequired,
  handleSetAddress: func.isRequired,
  setTypeFilter: func.isRequired,
  typeFilter: string,
  testDriveTypes: arrayOf(testDriveType),
};

export default MapSection;
